/**
 * @generated SignedSource<<7598ba02434bf1e34fb454bcb6d329e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AppBuildEnvironmentType = "PROD" | "STAGING" | "%future added value";
export type AppBuildVersionBumpType = "AUTO" | "BUILD" | "MAJOR" | "MINOR" | "NONE" | "PATCH" | "%future added value";
export type KickoffIosAppBuildInput = {
  brandId: string;
  env: AppBuildEnvironmentType;
  versionBump: AppBuildVersionBumpType;
};
export type InternBuildActionsPanelIOSMutation$variables = {
  input: KickoffIosAppBuildInput;
};
export type InternBuildActionsPanelIOSMutation$data = {
  readonly kickoffIosAppBuild: {
    readonly message: string;
    readonly pipelineId: string | null;
    readonly success: boolean;
  };
};
export type InternBuildActionsPanelIOSMutation = {
  response: InternBuildActionsPanelIOSMutation$data;
  variables: InternBuildActionsPanelIOSMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "KickoffIosAppBuildMutationPayload",
    "kind": "LinkedField",
    "name": "kickoffIosAppBuild",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pipelineId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternBuildActionsPanelIOSMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternBuildActionsPanelIOSMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "84f3eff2ac97a5851a0beab6313b50b9",
    "id": null,
    "metadata": {},
    "name": "InternBuildActionsPanelIOSMutation",
    "operationKind": "mutation",
    "text": "mutation InternBuildActionsPanelIOSMutation(\n  $input: KickoffIosAppBuildInput!\n) {\n  kickoffIosAppBuild(input: $input) {\n    success\n    message\n    pipelineId\n  }\n}\n"
  }
};
})();

(node as any).hash = "922e49c79510172b2f61d75db2f4d861";

export default node;
